import React, { useState, useRef } from 'react';
import Modal from 'react-modal';
import { translate } from '../Services/translation';

if (document.getElementById('image-gallery')) {
    Modal.setAppElement('#image-gallery');
}

const ImageGallery = ({ modalTitle = "", images = [], title = "", introduction = "" }) => {

    const [modalIsOpen, setIsOpen] = useState(false);

    async function openModal() {
        await setIsOpen(true);
        const element = document.getElementById('modal-img-' + event.target.id);
        if (element != null) {
            element.scrollIntoView();
        }
    }

    function closeModal() {
            setIsOpen(false);
        }

    return (
        <div>
            <div className="c-image-gallery">
                { title && <h2>{title}</h2> }
                { introduction && 
                    <div className="c-image-gallery__header">
                        <p>{introduction}</p>
                    </div> }
                <ul>
                { images &&
                    images.map((image, index) => (
                        <li key={index}>
                            <button id={index} key={index} type="button" className="btn btn-link" data-bs-toggle="modal" data-bs-target="#imageModal" onClick={openModal} >
                                <img key={index} src={image.imageUrl} alt={image.altText} />
                            </button>
                        </li>
                    ))}
                </ul>
                <button type="button" className="button button-secondary c-image-gallery__modal-show" onClick={openModal}> {translate('imagegalleryblock.showallimages')}</button>
            </div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                portalClassName={
                    "ReactModalPortal c-image-gallery__modal"
                }
                style={
                    {
                        overlay: {
                            zIndex: 1500
                        },
                        content: {}
                    }
                }
                >
                <div className="modal-dialog modal-fullscreen c-image-gallery__modal">
                        <div className="modal-content">
                        <div className="modal-header">
                            { modalTitle &&
                                <h1 className="modal-title" id="imageModalLabel">{modalTitle}</h1>
                            }
                            <button onClick={closeModal} type="button"  aria-label="Close">

                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                                    <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
                                </svg>


                            </button>
                            </div>
                            <div className="modal-body">
                                <div className="d-flex">
                                    <div className="mx-auto d-flex flex-column">
                                        {images &&
                                            images.map((image, index) => (
                                                <figure key={index} className="c-image-gallery__image">
                                                    <picture key={index}>
                                                        <img id={"modal-img-" + index} key={index} src={image.imageUrl} alt={image.altText} />
                                                    </picture>
                                                </figure>
                                            ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </Modal>
        </div>
    );
};

export default ImageGallery;